module.exports = __webpack_public_path__ + "img/shopify.130d3037.jpg";